export default {
  '个人信息':'Information',
  '修改密码':'Edit password',
  '姓名：':'Name:',
  '手机号：':'Phone Number:',
  '修改信息':'Modify Information',
  '姓 名':'Name',
  '请输入':'Please Enter',
  '当前密码':'Current Password',
  '新密码':'New Password',
  '确认密码':'Confirm Password',
  '取 消':'Cancel',
  '取消':'Cancel',
  '确 定':'Confirm',
  '确定':'Confirm',
  '接口出错':'Interface Error',
  '请输入姓名':'Please enter your name',
  '请输入完整信息':'Please enter complete information',
  '两次输入的密码不一致':'The two passwords entered do not match',
  '修改成功':'Modification successful',
  '修改成功,请重新登录':'Modification successful, please log in again',
}